module.exports = __webpack_public_path__ + "img/32.22a3140b.svg";